import { render, staticRenderFns } from "./Brief.vue?vue&type=template&id=6b9c7679"
import script from "./Brief.vue?vue&type=script&lang=js"
export * from "./Brief.vue?vue&type=script&lang=js"
import style0 from "./Brief.vue?vue&type=style&index=0&id=6b9c7679&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports